import { initMenuTemplates } from '@ui/composables'
import {
  usePagesStore,
} from 'pinia-store'

const usePages = usePagesStore()

export function getPagesTemplates() {
  const arr: any = []
  const menu = computed(() => initMenuTemplates(usePages.list))
  if (!menu.value || (Array.isArray(menu.value) && menu.value.length === 0))
    return arr

  for (let i = 0; i < menu.value.length; i++) {
    const el = menu.value[i]
    if (!el?.is_spa && (el?.is_footer || el?.is_navbar) && el?.slug) {
      arr.push({
        title: el?.page_title,
        slug: el?.slug,
        is_footer: el?.is_footer,
        is_spa: 0,
      })
    }
  }
  return arr
}
